export type PlatformId =
	| "amazon"
	| "rakuten"
	| "yahoo"
	| "instagram-feed"
	| "instagram-story"
	| "x-twitter"
	| "facebook"
	| "tiktok"
	| "pinterest"
	| "line"
	| "transparent";

export interface PlatformConfig {
	id: PlatformId;
	label: string;
	width: number;
	height: number;
	bgColor: string; // CSS color string or "transparent"
	padding: number; // px from each side
	minCoverage?: number; // 0-1, minimum product area ratio (Amazon: 0.85)
}

export const PLATFORM_CONFIGS: Record<PlatformId, PlatformConfig> = {
	// EC Mall formats
	amazon: {
		id: "amazon",
		label: "Amazon",
		width: 1600,
		height: 1600,
		bgColor: "#FFFFFF",
		padding: 0,
		minCoverage: 0.85,
	},
	rakuten: {
		id: "rakuten",
		label: "楽天",
		width: 700,
		height: 700,
		bgColor: "#FFFFFF",
		padding: 35,
	},
	yahoo: {
		id: "yahoo",
		label: "Yahoo!ショッピング",
		width: 1600,
		height: 1600,
		bgColor: "#FFFFFF",
		padding: 0,
	},
	// SNS formats
	"instagram-feed": {
		id: "instagram-feed",
		label: "Instagram フィード",
		width: 1080,
		height: 1080,
		bgColor: "#FFFFFF",
		padding: 54,
	},
	"instagram-story": {
		id: "instagram-story",
		label: "Instagram ストーリー",
		width: 1080,
		height: 1920,
		bgColor: "#FFFFFF",
		padding: 54,
	},
	"x-twitter": {
		id: "x-twitter",
		label: "X (Twitter)",
		width: 1200,
		height: 675,
		bgColor: "#FFFFFF",
		padding: 60,
	},
	facebook: {
		id: "facebook",
		label: "Facebook",
		width: 1200,
		height: 630,
		bgColor: "#FFFFFF",
		padding: 60,
	},
	tiktok: {
		id: "tiktok",
		label: "TikTok",
		width: 1080,
		height: 1920,
		bgColor: "#FFFFFF",
		padding: 54,
	},
	pinterest: {
		id: "pinterest",
		label: "Pinterest",
		width: 1000,
		height: 1500,
		bgColor: "#FFFFFF",
		padding: 50,
	},
	line: {
		id: "line",
		label: "LINE",
		width: 1040,
		height: 1040,
		bgColor: "#FFFFFF",
		padding: 52,
	},
	// Original transparent PNG
	transparent: {
		id: "transparent",
		label: "透過PNG (オリジナルサイズ)",
		width: 0, // dynamic
		height: 0, // dynamic
		bgColor: "transparent",
		padding: 0,
	},
};

export const EC_PLATFORMS: PlatformId[] = ["amazon", "rakuten", "yahoo"];
export const SNS_PLATFORMS: PlatformId[] = [
	"instagram-feed",
	"instagram-story",
	"x-twitter",
	"facebook",
	"tiktok",
	"pinterest",
	"line",
];
